import axios, { AxiosInstance } from "axios"
import api from "@/services/api"
import { Feature, Tenant } from "@/types/tenant"
import { SystemUser } from "@/types/user"
import { SystemAudit } from "@/types/audit"

class SystemApi {
	private get axios (): AxiosInstance {
		return api.getAxios()
	}

	public async tenantsGet (): Promise<Tenant[]> {
		return (await this.axios.get("/sysadmin/tenants")).data
	}

	public async features (): Promise<Feature[]> {
		return (await this.axios.get("/sysadmin/tenants/features")).data
	}

	public async enabledFeatures (tenantId: string): Promise<{ [key: string]: boolean }> {
		return (await this.axios.get(`/sysadmin/tenants/${tenantId}/features`)).data
	}

	public async enabledFeaturesSet (tenantId: string, features: { [key: string]: boolean }): Promise<void> {
		await this.axios.put(`/sysadmin/tenants/${tenantId}/features`, features)
	}

	public async systemUsers (): Promise<SystemUser[]> {
		return (await this.axios.get("/sysadmin/adminUser")).data
	}

	public async systemUserSave (user: SystemUser): Promise<void> {
		await this.axios.put("/sysadmin/adminUser", user)
	}

	public async systemUserDelete (user: SystemUser): Promise<void> {
		await this.axios.delete(`/sysadmin/adminUser/${user.id}`)
	}

	public async accessTenant (tenantId: string, reason: string): Promise<void> {
		await this.axios.post(`/sysadmin/adminUser/accessTenant/${tenantId}`, {
			reason
		})
	}

	public async switchToTenant (): Promise<void> {
		await this.axios.post("/sysadmin/adminUser/switchToTenant")
	}

	public async endTenantAccess (): Promise<void> {
		await this.axios.post("/sysadmin/adminUser/accessTenantEnd")
	}

	public async systemAuditGet (): Promise<SystemAudit[]> {
		return (await this.axios.get("/sysadmin/audit")).data
	}

	public async featureDocumentationGet (featureKey: string): Promise<string> {
		return (await this.axios.get(`/features/FeatureDocumentation/${featureKey}`)).data
	}
}

const systemnApi = new SystemApi()
export default systemnApi
